export const hotelCasaBlanca = [
  "assets/images/hotels/xilitla/CASABLANCA/image1.jpeg",
  "assets/images/hotels/xilitla/CASABLANCA/image2.jpeg",
  "assets/images/hotels/xilitla/CASABLANCA/image3.jpeg",
  "assets/images/hotels/xilitla/CASABLANCA/image4.jpeg",
  "assets/images/hotels/xilitla/CASABLANCA/video1.mp4",
];

export const hotelCafeNaranja = [
  "assets/images/hotels/xilitla/CAFEYNARANJA/image1.jpeg",
  "assets/images/hotels/xilitla/CAFEYNARANJA/image2.jpeg",
  "assets/images/hotels/xilitla/CAFEYNARANJA/image3.jpeg",
  "assets/images/hotels/xilitla/CAFEYNARANJA/image4.jpeg",
  "assets/images/hotels/xilitla/CAFEYNARANJA/image5.jpeg",
  "assets/images/hotels/xilitla/CAFEYNARANJA/image6.jpeg",
];

export const hotelCaminoSurreal = [
  "assets/images/hotels/xilitla/CAMINOSURREAL/image1.jpeg",
  "assets/images/hotels/xilitla/CAMINOSURREAL/image2.jpeg",
  "assets/images/hotels/xilitla/CAMINOSURREAL/image3.jpeg",
  "assets/images/hotels/xilitla/CAMINOSURREAL/image4.jpeg",
  "assets/images/hotels/xilitla/CAMINOSURREAL/image5.jpeg",
  "assets/images/hotels/xilitla/CAMINOSURREAL/image6.jpeg",
];

export const hotelMagnolia = [
  "assets/images/hotels/xilitla/HOTELMAGNOLIA/image1.jpeg",
  "assets/images/hotels/xilitla/HOTELMAGNOLIA/image2.jpeg",
  "assets/images/hotels/xilitla/HOTELMAGNOLIA/image3.jpeg",
  "assets/images/hotels/xilitla/HOTELMAGNOLIA/image4.jpeg",
  "assets/images/hotels/xilitla/HOTELMAGNOLIA/image5.jpeg",
];

export const hotelRealDeLua = [
  "assets/images/hotels/xilitla/HOTELREALDELUA/image1.jpeg",
  "assets/images/hotels/xilitla/HOTELREALDELUA/image2.jpeg",
  "assets/images/hotels/xilitla/HOTELREALDELUA/image3.jpeg",
  "assets/images/hotels/xilitla/HOTELREALDELUA/image4.jpeg",
  "assets/images/hotels/xilitla/HOTELREALDELUA/image5.jpeg",
];

export const hotelSierraLinda = [
  "assets/images/hotels/xilitla/HOTELSIERRALINDA/image1.jpeg",
  "assets/images/hotels/xilitla/HOTELSIERRALINDA/image2.jpeg",
  "assets/images/hotels/xilitla/HOTELSIERRALINDA/image3.jpeg",
  "assets/images/hotels/xilitla/HOTELSIERRALINDA/image4.jpeg",
  "assets/images/hotels/xilitla/HOTELSIERRALINDA/image5.jpeg",
];

export const hotelZiyaketzas = [
  "assets/images/hotels/xilitla/HOTELZIYAKETZAS/image1.jpeg",
  "assets/images/hotels/xilitla/HOTELZIYAKETZAS/image2.jpeg",
  "assets/images/hotels/xilitla/HOTELZIYAKETZAS/image3.jpeg",
];

export const hotelHotelValles = [
  "assets/images/hotels/valles/HOTELVALLES/image1.jpg",
  "assets/images/hotels/valles/HOTELVALLES/image2.jpg",
  "assets/images/hotels/valles/HOTELVALLES/image3.jpg",
  "assets/images/hotels/valles/HOTELVALLES/image4.jpg",
];

export const hotelHuaxtecaInn = [
  "assets/images/hotels/valles/HUAXTECAINN/image1.jpg",
  "assets/images/hotels/valles/HUAXTECAINN/image2.jpg",
  "assets/images/hotels/valles/HUAXTECAINN/image3.webp",
  "assets/images/hotels/valles/HUAXTECAINN/image4.jpg",
];

export const hotelPopeye = [
  "assets/images/hotels/valles/HOTELPOPEYE/image1.jpg",
  "assets/images/hotels/valles/HOTELPOPEYE/image2.jpg",
  "assets/images/hotels/valles/HOTELPOPEYE/image3.jpg",
  "assets/images/hotels/valles/HOTELPOPEYE/image4.jpg",
  "assets/images/hotels/valles/HOTELPOPEYE/image5.jpg",
];

export const hotelPiña = [
  "assets/images/hotels/valles/HOTELPIÑA/image1.jpg",
  "assets/images/hotels/valles/HOTELPIÑA/image2.jpg",
  "assets/images/hotels/valles/HOTELPIÑA/image3.jpg",
  "assets/images/hotels/valles/HOTELPIÑA/image4.jpg",
];

export const hotelGrannHotel = [
  "assets/images/hotels/valles/GRANNHOTEL/image1.jpg",
  "assets/images/hotels/valles/GRANNHOTEL/image2.jpg",
  "assets/images/hotels/valles/GRANNHOTEL/image3.jpg",
  "assets/images/hotels/valles/GRANNHOTEL/image4.jpg",
  "assets/images/hotels/valles/GRANNHOTEL/image5.jpg",
];

export const tours = [
  "assets/images/tours/zacahuil/image1.jpg",
  "assets/images/tours/zacahuil/image2.jpg",
  "assets/images/tours/zacahuil/image3.jpeg",
  "assets/images/tours/zacahuil/image4.jpeg",
  "assets/images/tours/bocoles/image1.jpeg",
  "assets/images/tours/bocoles/image2.jpeg",
  "assets/images/tours/bocoles/image3.jpeg",
  "assets/images/tours/bocoles/image4.jpeg",
  "assets/images/tours/enchiladas/image1.jpeg",
  "assets/images/tours/enchiladas/image2.jpeg",
  "assets/images/tours/enchiladas/image3.jpeg",
  "assets/images/tours/enchiladas/image4.jpeg",
  "assets/images/tours/enchiladas/image5.jpeg",
  "assets/images/tours/acamayas/image1.jpeg",
  "assets/images/tours/acamayas/image2.jpeg",
  "assets/images/tours/acamayas/image3.jpeg",
  "assets/images/tours/acamayas/image4.jpeg",
  "assets/images/tours/mojarras/image1.jpg",
  "assets/images/tours/mojarras/image2.jpeg",
  "assets/images/tours/mojarras/image3.jpeg",
  "assets/images/tours/mojarras/image4.jpeg",
];
